<div class="screen-actions flex justify-between items-center p-1 select-none">
  <p-button
    class="mr-1"
    severity="secondary"
    [text]="true"
    [rounded]="true"
    icon="pi pi-bars"
    [ariaLabel]="'common.a11y.open_navigation_menu' | translate"
    [pt]="$any({ root: { 'data-testid': 'screen-actions-menu-button' } })"
    (onClick)="openMenu()"
  />
  <div class="screen-actions-content flex-1 flex items-center justify-end leading-none">
    <ng-content />
  </div>
</div>

<p-drawer
  [visible]="drawerVisible()"
  (visibleChange)="onDrawerVisibleChange($event)"
  position="left"
  [appendTo]="'body'"
  styleClass="w-60"
  [transitionOptions]="'0ms'"
  [dismissible]="!dragging()"
>
  <ng-template #headless>
    <nav class="main-menu select-none" [attr.aria-label]="'navigations.menu' | translate">
      <ng-container *ngTemplateOutlet="menuList; context: { area: 'top' }" />

      <section
        class="overflow-section"
        [class.overflow-section-active]="overflowContainsActiveRoute() && !overflowExpanded()"
      >
        <div class="overflow-header">
          <button
            type="button"
            class="overflow-toggle"
            [attr.aria-expanded]="overflowExpanded()"
            [attr.aria-controls]="'main-menu-overflow'"
            (click)="toggleOverflow()"
          >
            <i
              class="pi"
              [class.pi-chevron-down]="overflowExpanded()"
              [class.pi-chevron-right]="!overflowExpanded()"
            ></i>
            <span>{{ 'navigations.overflow' | translate }}</span>
          </button>

          @if (overflowExpanded()) {
            <button
              type="button"
              class="menu-control edit-toggle"
              [class.edit-toggle-active]="editMode()"
              [attr.aria-pressed]="editMode()"
              [attr.aria-label]="(editMode() ? 'navigations.done_editing_menu' : 'navigations.edit_menu') | translate"
              (click)="setEditMode(!editMode())"
            >
              <i class="pi" [class.pi-pencil]="!editMode()" [class.pi-check]="editMode()"></i>
            </button>
          }
        </div>

        @if (overflowExpanded()) {
          <ng-container *ngTemplateOutlet="menuList; context: { area: 'overflow' }" />
        }
      </section>

      <div class="menu-spacer"></div>

      <div class="menu-separator"></div>

      <ng-container *ngTemplateOutlet="menuList; context: { area: 'bottom' }" />

      <button
        type="button"
        class="menu-row settings-row"
        [class.menu-row-active]="isRouteActive('/settings')"
        (click)="activateSettings()"
      >
        <i class="pi pi-cog menu-icon"></i>
        <span>{{ 'navigations.settings' | translate }}</span>
      </button>
    </nav>
  </ng-template>
</p-drawer>

<ng-template #menuList let-area="area">
  <div
    cdkDropList
    [id]="'main-menu-' + area"
    [cdkDropListData]="area"
    [cdkDropListConnectedTo]="dropListIds"
    [cdkDropListDisabled]="!editMode()"
    class="menu-area"
    [class.menu-area-empty]="editMode() && !hasRenderedItems(area)"
    (cdkDropListDropped)="onDrop($event, area)"
  >
    @for (row of renderedRows(area); track row.id) {
      @if (itemById(row.id); as item) {
        <div
          cdkDrag
          [cdkDragData]="item.id"
          [cdkDragDisabled]="!editMode()"
          class="menu-row"
          [class.menu-row-active]="!!item.routerLink && isRouteActive(item.routerLink)"
          [class.menu-row-disabled]="item.disabled"
          (cdkDragStarted)="dragging.set(true)"
          (cdkDragEnded)="dragging.set(false)"
        >
          @if (editMode()) {
            <button
              type="button"
              cdkDragHandle
              class="menu-control drag-handle"
              [attr.aria-label]="'navigations.drag_menu_item' | translate: { item: item.label }"
            >
              <i class="pi pi-bars"></i>
            </button>
          }

          <button type="button" class="menu-item-action" [disabled]="item.disabled" (click)="activateItem(item)">
            <i [class]="item.icon + ' menu-icon'"></i>
            <span>{{ item.label }}</span>
          </button>

          @if (editMode()) {
            <button
              type="button"
              class="menu-control divider-toggle"
              [class.divider-toggle-active]="row.separatorAfter !== null"
              [attr.aria-pressed]="row.separatorAfter !== null"
              [attr.aria-label]="
                (row.separatorAfter === null ? 'navigations.add_separator_after' : 'navigations.remove_separator')
                  | translate: { item: item.label }
              "
              (click)="toggleDivider(area, row)"
            >
              <i
                class="pi"
                [class.pi-minus]="row.separatorAfter === null"
                [class.pi-minus-circle]="row.separatorAfter !== null"
              ></i>
            </button>
          }
        </div>

        @if (row.separatorAfter !== null) {
          <div class="menu-separator"></div>
        }
      }
    }

    @if (editMode() && !hasRenderedItems(area)) {
      <span class="empty-drop-label">{{ 'navigations.drop_menu_items_here' | translate }}</span>
    }
  </div>
</ng-template>
